import {Component, OnInit} from '@angular/core';
import {LoginModel, RegisterModel} from "../../../../../Models/login-model";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../../Service/auth.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Router} from "@angular/router";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
    userData: RegisterModel = new RegisterModel();
    phoneNumber: number;

    constructor(private toastr: ToastrService, private authService: AuthService, private route: Router) {
        if (localStorage.getItem("token") && this.authService.getuserInfo())
            this.route.navigateByUrl("/home");


    }

    ngOnInit(): void {
    }

    Register(registerForm: any) {
        debugger;
        if (!registerForm.valid) {
            return this.toastr.error('Please Enter Your Data Correct', '', {
                timeOut: 3000,
            });
        }
        if (this.userData.password != this.userData.confirmPassword) {
            return this.toastr.error('Password and Confirm Password Not Matching', 'Error', {
                timeOut: 3000,
            });
        }
        if (!this.userData.email.toLowerCase().includes("@gmail.com")) {
            return this.toastr.error('Email Must be Google Email', 'Error', {
                timeOut: 3000,
            });
        }
        this.userData.phoneNumber = this.phoneNumber.toString();
        this.authService.Register(this.userData).subscribe(res => {
            this.toastr.success('Email Created Success', 'Please Login In Site ', {
                timeOut: 3000,
            });
            return this.route.navigateByUrl("/Account/login");
        }, errors => {
            this.toastr.error(errors.error, 'Error', {
                timeOut: 3000,
            });
            /*let lstErrors = Object.keys(errors.error).map(key => ({type: key, value: errors.error[key]}))
            lstErrors.forEach(res => {

            });*/

        });
    }
}
